import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Spinner } from 'react-bootstrap'
import { switchProfile } from 'src/api/authService'
import StudentLayout from 'src/layout/StudentLayout'
import TeacherLayout from 'src/layout/TeacherLayout'
import AdminLayout from 'src/layout/AdminLayout'
import VerifierLayout from 'src/layout/VerifierLayout'
import HomeLayout from 'src/layout/HomeLayout'
import { savePendingRedirect, clearPendingRedirect } from 'src/hooks/usePendingRedirect'

const TestCodeRedirect = () => {
  const { testKey } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const token = window.localStorage.getItem('token')
  const userDetails = useSelector((state) => state.userDetails)
  const profileType = userDetails?.[0]?.profileType
  const [switching, setSwitching] = useState(false)

  const reservedRoots = [
    'student',
    'teacher',
    'admin',
    'verifier',
    'login',
    'register',
    'add-profile',
  ]

  useEffect(() => {
    if (reservedRoots.includes(testKey)) {
      return
    }
    if (!token) {
      savePendingRedirect(`/${testKey}`)
      navigate('/', { replace: true })
      return
    }
    if (userDetails && userDetails.length > 0) {
      if (profileType !== 'Student') {
        const studentProfiles = userDetails.filter((p) => p.profileType === 'Student')
        if (studentProfiles.length >= 1) {
          const autoSwitch = async () => {
            try {
              setSwitching(true)
              const res = await switchProfile(studentProfiles[0].key)
              if (res?.status === 'SUCCESS') {
                window.localStorage.setItem('token', res.token)
                dispatch({ type: 'set', res: res.profiles || [] })
              }
            } catch (err) {
              console.error('Failed to auto switch profile:', err)
            } finally {
              setSwitching(false)
            }
          }
          autoSwitch()
        } else {
          savePendingRedirect(`/${testKey}`)
          navigate('/add-profile', { state: { accountRole: 'Student' } })
        }
      } else {
        clearPendingRedirect()
        navigate(`/student/test-intro/${testKey}`, { replace: true })
      }
    } else {
      const timer = setTimeout(() => {
        if (!userDetails || userDetails.length === 0) {
          navigate('/', { replace: true })
        }
      }, 1500)
      return () => clearTimeout(timer)
    }
  }, [token, userDetails, profileType, testKey, navigate, dispatch])
  if (reservedRoots.includes(testKey)) {
    if (testKey === 'student') return <StudentLayout />
    if (testKey === 'teacher') return <TeacherLayout />
    if (testKey === 'admin') return <AdminLayout />
    if (testKey === 'verifier') return <VerifierLayout />
    return <HomeLayout />
  }

  if (switching || token) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="success" />
      </div>
    )
  }

  return null
}

export default TestCodeRedirect
